import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Stack, Typography } from '@mui/material';
import { IAlertProps } from '../../interface/IAlertProps';
import {
  getDefaultAlertProps,
  gteMd5Conspect,
  HandleMaxSupport,
  HandleTelegramSupport,
  HandleVkSupport,
} from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import Logo from '../../image/webp_Logo2.webp';
import { MyButton } from '../UI/MyButton';
import NameSkeleton from '../../image/Name.svg';
import Tgamm from '../../image/Tg.png';
import Tgamm2 from '../../image/maxx.png';
import Tgamm5 from '../../image/Vk.png';
import { DESCTOP_CHANGE, WINDOW_H, WINDOW_V } from '../../constant/constants';

export const LendingDivSupport = () => {
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );

  const [timestampReal, setTimestamp] = useState(Math.floor(Date.now() / 1000));

  const [constHeight, setConstHeight] = useState(window.innerWidth);

  const [windowState, setWindowState] = useState(
    window.innerWidth > DESCTOP_CHANGE ? WINDOW_H : WINDOW_V
  );
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handlerChange = () => {
    let cnt = WINDOW_V;
    if (window.innerWidth > DESCTOP_CHANGE) {
      cnt = WINDOW_H;
    }
    setWindowState(cnt);
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    handlerChange();
    setConstHeight(window.innerHeight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handlerChange, false);
    return () => {
      window.removeEventListener('resize', handlerChange, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { idSupport, timestamp, crc } = useParams();

  if (idSupport !== undefined) {
    if (timestamp === undefined || crc === undefined) {
      return <div> </div>;
    }

    const unixtTime = timestamp;
    const diff = timestampReal - parseInt(unixtTime, 10);

    if (diff > 3600) {
      return <div> </div>;
    }

    const toMd5 = `${unixtTime}nurlat${idSupport}`;
    const md5Secure = gteMd5Conspect(toMd5);

    if (md5Secure !== crc) {
      return <div> </div>;
    }
  }

  return (
    <Stack
      style={{
        WebkitTextSizeAdjust: '100%',
      }}
    >
      <Stack
        width="100%"
        direction="column"
        sx={{
          top: 0,
          left: 0,
          position: 'absolute',
          overflow: 'hidden',
        }}
      >
        <MyAlert
          message={alertProps.message}
          severity={alertProps.severity}
          onClose={() => setAlertProps({ ...alertProps, message: '' })}
        />
        <Stack
          width="100%"
          height={constHeight}
          justifyContent="space-between"
          sx={{
            background: '#E5EAED',
          }}
        >
          <Stack padding="20px" direction="row" alignItems="center" spacing={2}>
            <img alt="" width="50px" height="50px" src={Logo} />
            <img alt="" width="90px" height="26px" src={NameSkeleton} />
          </Stack>
          <Stack alignItems="center" justifyContent="center" spacing={1}>
            <Typography
              paddingBlockEnd="20px"
              fontWeight={400}
              fontFamily="Roboto"
              lineHeight="21px"
              fontSize="14px"
              letterSpacing="0.3px"
              textAlign="center"
              width="200px"
              color="#000000"
              component="text"
            >
              Выберите мессенджер для связи с поддержкой
            </Typography>
            <MyButton
              text={
                <Stack
                  width="100%"
                  alignItems="center"
                  justifyContent="space-between"
                  direction="row"
                >
                  <Typography
                    fontWeight={400}
                    paddingLeft="20px"
                    fontFamily="Roboto"
                    lineHeight="100%"
                    fontSize="14px"
                    letterSpacing="0.3px"
                    textAlign="left"
                    color="#FFFFFF"
                    component="text"
                  >
                    Написать в Telegram
                  </Typography>
                  <Stack>
                    <img alt="" width="32px" height="32px" src={Tgamm} />
                  </Stack>
                </Stack>
              }
              background="#29A9EB"
              color="#29A9EB"
              borderRadius="25px"
              width="250px"
              height="60px"
              onClick={() =>
                HandleTelegramSupport(idSupport === undefined ? '' : idSupport)
              }
            />
            <MyButton
              text={
                <Stack
                  width="100%"
                  alignItems="center"
                  justifyContent="space-between"
                  direction="row"
                >
                  <Typography
                    fontWeight={400}
                    paddingLeft="20px"
                    fontFamily="Roboto"
                    lineHeight="100%"
                    fontSize="14px"
                    letterSpacing="0.3px"
                    textAlign="left"
                    color="#FFFFFF"
                    component="text"
                  >
                    Написать в Вконтакте
                  </Typography>
                  <Stack>
                    <img alt="" width="32px" height="32px" src={Tgamm5} />
                  </Stack>
                </Stack>
              }
              background="#0077ff"
              color="#0077ff"
              borderRadius="25px"
              width="250px"
              height="60px"
              onClick={() =>
                HandleVkSupport(idSupport === undefined ? '' : idSupport)
              }
            />
            <MyButton
              text={
                <Stack
                  width="100%"
                  alignItems="center"
                  justifyContent="space-between"
                  direction="row"
                >
                  <Typography
                    fontWeight={400}
                    paddingLeft="20px"
                    fontFamily="Roboto"
                    lineHeight="100%"
                    fontSize="14px"
                    letterSpacing="0.3px"
                    textAlign="left"
                    color="#FFFFFF"
                    component="text"
                  >
                    Написать в MAX
                  </Typography>
                  <Stack>
                    <img alt="" width="32px" height="32px" src={Tgamm2} />
                  </Stack>
                </Stack>
              }
              background="#9D29EB"
              color="#9D29EB"
              borderRadius="25px"
              width="250px"
              height="60px"
              onClick={() =>
                HandleMaxSupport(idSupport === undefined ? '' : idSupport)
              }
            />
          </Stack>
          <div> </div>
        </Stack>
      </Stack>
    </Stack>
  );
};
